import { BaseReactiveClass } from '@/classes/BaseReactiveClass';
import { SM_STATUS } from 'Const/investment.json';
import { FarmClass } from '@/classes/FarmClass';
import { MarketOfferBidClass } from '@/classes/MarketOfferBidClass';
import { httpClientMarket } from 'Api/microservice-http-clients';

export class MarketOfferClass extends BaseReactiveClass {
  constructor(props) {
    super(props);

    this.$set('$dataLoading', this.$dataLoading || false);
    this.$set('_farm', this._farm || new FarmClass());
  }

  get isStatusActive() {
    return this.status === SM_STATUS.ACTIVE;
  }

  get isStatusSalePending() {
    return this.status === SM_STATUS.SALE_PENDING;
  }

  get isStatusSold() {
    return this.status === SM_STATUS.SOLD;
  }

  get isStatusCancelled() {
    return this.status === SM_STATUS.CANCELLED;
  }

  get isStatusExpired() {
    return this.status === SM_STATUS.EXPIRED;
  }

  get isSold() {
    return this.isStatusSalePending || this.isStatusSold;
  }

  get isCancelled() {
    return this.isStatusCancelled || this.isStatusExpired;
  }

  get hasAcceptedBid() {
    return this.bids.some(bid => bid.status === SM_STATUS.ACCEPTED);
  }

  set farm(farmData) {
    this.$set('_farm', new FarmClass(farmData));
  }

  get farm() {
    return this._farm;
  }

  get bids() {
    return this._bids;
  }

  set bids(bids) {
    const bidList = (bids || []).map(bidData => new MarketOfferBidClass(bidData));
    this.$set('_bids', bidList);
  }

  get hasBids() {
    return Boolean(this.pending_bids);
  }

  get hasOwnBid() {
    return Boolean(this.has_your_bid);
  }

  get isOwn() {
    return Boolean(this.your);
  }

  get isOwnBidStatusAccepted() {
    return this.your_bid_status === SM_STATUS.ACCEPTED;
  }

  get isOwnBidStatusConfirmed() {
    return this.your_bid_status === SM_STATUS.CONFIRMED;
  }

  get isOwnBidStatusActive() {
    return this.your_bid_status === SM_STATUS.ACTIVE;
  }

  get remainingHoldingPeriodYears() {
    const value = String(this.remaining_holding_period);
    if (['1', 'present-1'].includes(value)) return `${value} Year`;
    return `${value} Years`;
  }

  get amountWithFee() {
    // to fixed here to avoid JS calculation error
    // https://javascript.plainenglish.io/why-0-1-0-2-0-3-in-javascript-d7e218224a72
    return Number((this.amount * 1.01).toFixed(2));
  }

  async getOfferData() {
    this.$dataLoading = true;
    try {
      const { data } = await httpClientMarket.get(`/offer/${this.id}`);
      this.$setAll(data);
    } finally {
      this.$dataLoading = false;
    }
  }

  async sendAcceptBid(bidId) {
    await httpClientMarket.post(`/offer/${this.id}/accept/${bidId}`);
  }
}
